export default __webpack_public_path__ + "media/icons/default-upload-img-f5405435.svg";